import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import type { Task } from 'ember-concurrency';
import FocusTrapper from 'ember-focus-trapper/components/focus-trapper';
import ButtonGroup from 'garaje/components/ui/button-group';
import ModalDialog from 'garaje/components/ui/classic/modal-dialog';
import type VisitorDocument from 'garaje/models/visitor-document';

interface RemoveVisitorDocumentConfirmationSignature {
  Args: {
    close: () => void;
    onSubmitTask: Task<void, [SubmitEvent]>;
    visitorDocument: VisitorDocument;
  };
}

export default <template>
  <ModalDialog @clickOutsideToClose={{false}} @targetAttachment="center" @translucentOverlay={{true}}>
    <FocusTrapper>
      <div data-test-remove-visitor-document-modal class="p-16">
        <h1 class="mb-8" data-test-header>Delete document</h1>
        <form {{on "submit" @onSubmitTask.perform}}>
          <p>
            Are you sure you want to delete the
            {{@visitorDocument.title}}
            document? This cannot be undone.
          </p>
          <ButtonGroup @reverse={{true}} class="pt-8 flex justify-end">
            <button
              class="btn btn--small btn--brand {{if @onSubmitTask.isRunning 'disabled'}}"
              disabled={{@onSubmitTask.isRunning}}
              type="submit"
              data-test-delete-confirm
            >
              {{#if @onSubmitTask.isRunning}}
                Deleting...
              {{else}}
                Delete
              {{/if}}
            </button>
            <button
              class="btn btn--small btn--hoverFill {{if @onSubmitTask.isRunning 'disabled'}}"
              disabled={{@onSubmitTask.isRunning}}
              {{on "click" @close}}
              type="button"
              data-test-delete-cancel
            >
              Cancel
            </button>
          </ButtonGroup>
        </form>
      </div>
    </FocusTrapper>
  </ModalDialog>
</template> satisfies TOC<RemoveVisitorDocumentConfirmationSignature>;
